export const getEmployeeImageUrl = (id, employeeList, currentUser) => {
  if (!employeeList) return;
  const user = employeeList.find((u) => u.key == id);
  if (!user && currentUser.userDetails.id == id) {
    return currentUser?.userDetails?.profile_pic;
  }
  return user?.Image;
};
